<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons  slot="start">
      <ion-button (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title> Change Password </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form
    *ngIf="stylistChangePasswordForm"
    [formGroup]="stylistChangePasswordForm"
    (ngSubmit)="onStylistChangePasswordFormSave()"
  >
    <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

    <ion-item class="ion-text-wrap">
      <p *ngIf="errorMessage || errorMessage != ''" class="smr-error">
        {{ errorMessage }}
      </p>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">Current Password *</ion-label>
      <ion-input
        type="password"
        name=""
        formControlName="currentPassword"
        fill="clear"Input
      ></ion-input>
    </ion-item>

    <ion-item
      [hidden]="
        currentPassword.valid || (currentPassword.pristine && !submitted)
      "
    >
      <p *ngIf="currentPassword.hasError('required')" class="smr-error">
        Current password is required.
      </p>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">New Password *</ion-label>
      <ion-input
        type="password"
        name=""
        formControlName="newPassword1"
        fill="clear"Input
      ></ion-input>
    </ion-item>

    <ion-item
      [hidden]="newPassword1.valid || (newPassword1.pristine && !submitted)"
    >
      <p *ngIf="newPassword1.hasError('required')" class="smr-error">
        New Password is required.
      </p>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">Repeat New Password *</ion-label>
      <ion-input
        type="password"
        name=""
        formControlName="newPassword2"
        fill="clear"Input
      ></ion-input>
    </ion-item>

    <ion-item
      [hidden]="newPassword2.valid || (newPassword2.pristine && !submitted)"
    >
      <p *ngIf="newPassword2.hasError('required')" class="smr-error">
        New Password is required.
      </p>
    </ion-item>
    <br />
    <div class="ion-padding">
      <ion-button type="submit" expand="block" color="primary">Save</ion-button>
    </div>
    <br />
    <br />
  </form>
</ion-content>
